var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-range-contianer"},[_c('label',{attrs:{"for":"range-selector"}},[_vm._v("Select a date range")]),_c('input',{ref:"date-range-selector",attrs:{"name":"range-selector"}})])}
var staticRenderFns = []

export { render, staticRenderFns }